import { useMachine } from '@xstate/react'
import { useEffect } from 'react'

import { ApiBusinessUnit } from '../../../api/_legacy/generated-api'
import { Client, Strategy } from '../types'
import { BusinessUnitEditor } from './business-unit-editor'
import { editBusinessUnitMachine } from './edit-business-unit.state'

export type Props = {
  businessUnit: ApiBusinessUnit
  client: Client
  clientId: string
  isSaveSuccessful: boolean
  onSaveSuccess: () => void
  strategies: Strategy[]
}

export function EditBusinessUnit({
  businessUnit,
  client,
  clientId,
  isSaveSuccessful,
  onSaveSuccess,
  strategies
}: Props) {
  const [machine, send] = useMachine(editBusinessUnitMachine)
  const state = machine.context

  useEffect(() => {
    send({ type: 'INIT_EDIT', businessUnit, clientId, onSaveSuccess })
  }, [businessUnit, clientId, onSaveSuccess, send])

  return (
    <BusinessUnitEditor
      businessUnit={state.businessUnit}
      client={client}
      errorMessages={state.errorMessages}
      errors={state.errors}
      isSaveSuccessful={isSaveSuccessful}
      saveButtonText="Save"
      strategies={strategies}
      onMutate={mutation => send({ type: 'MUTATE', mutation })}
      onSave={businessUnit => send({ type: 'SAVE_UPDATE', businessUnit })}
    />
  )
}
